import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetPerformancekragoalsemployee(id) {
  return useQuery(
    ['kragoals-performance-reports-employee', id],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.KRA_GOALS, {
          performance_report_id: id,
        })
      );

      return response.data;
    },
    {
      enabled: !!id,
    }
  );
}
